<template>
    <el-dialog class="item-dialog" :visible.sync="display" :width="width" :before-close="handleClose">
        <template slot="title">
            <p class="dialog-title" v-text="title"></p>
        </template>

        <slot></slot>

        <template slot="footer">
            <div class="dialog-footer">
                <el-button class="form-dialog-btn" type="primary" :loading="loading" @click="submit">{{
                    confirmText
                }}</el-button
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button class="close-btn" @click="handleClose">取消</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
export default {
    name: 'CM_FormDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '40%'
        },
        title: {
            type: String,
            default: '标题'
        },
        confirmText: {
            type: String,
            default: '确认'
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible (v) {
            this.display = v;
        }
    },
    data () {
        return {
            display: false
        };
    },
    methods: {
        // 通知提交
        submit () {
            this.$emit('submit');
        },

        // 拦截关闭操作
        handleClose () {
            this.$emit('close');
            this.display = false;
            this.$emit('update:visible', false);
        }
    }
};
</script>
<style lang="less" scoped>
.item-dialog {
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #ebeef5;
        .dialog-title {
            margin: 0;
            padding: 6px 6px 12px 6px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(48, 49, 51, 1);
            line-height: 16px;
        }
        .dialog-footer {
            text-align: center;
        }
    }
    /deep/ .el-button {
        font-size: 12px;
        font-weight: bold;
        font-family: PingFangSC;
        padding: 10px 20px;
        min-width: 98px;
    }
    .close-btn {
        border: 1px solid #2f9eff;
        color: #2f9eff;
        background: #fff;
    }

    /deep/ .el-dialog__footer {
        border-top: 1px solid #ebeef5;
        text-align: center;
        padding-top: 24px;
        padding-bottom: 24px;
    }
}
</style>
